// TODO: import from payer when available
export const TransactionType = {
  AUTH: 'auth',
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
}
